import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';

type Props = {
  onClick: () => void;
  size?: 'small' | 'medium';
};

export default function CloseButton({ onClick, size = 'small' }: Props) {
  return (
    <IconButton onClick={onClick} size={size}>
      <Close />
    </IconButton>
  );
}
